import { useState } from 'react';

const CourseTypeOne = ({ data, classes }) => {

    const [selectedMeet, setSelectedMeet] = useState(Object.keys(data.meetOptions || {})[0]);

    const handleSelectMeet = (meetKey) => {
        setSelectedMeet(meetKey);
    };

    const meetData = data.meetOptions?.[selectedMeet];
    const hideiPassDuration = data.id;

      // Prevent crash if data or meetOptions is undefined
    // if (!data || !data.meetOptions) {
    //     return  <div>Loading...</div>;
    // }

    return (
        <div className={`course-item ${classes || ''}`}>
            <div className="course-style-5 bg-white">
                <div className="course-header">
                    <div className="course-thumb">
                        <img src={`${process.env.PUBLIC_URL}/assets/images/course/course-01/${data.image}`} alt="Course Thumb" className="img-fluid"/>
                        <div className="course-price">
                            {meetData?.price === 0 || meetData?.price === "0" ? (
                                <div className="price current-price">Free</div>
                            ) : (
                                <div className="price current-price">Rp. {meetData?.price}</div>
                            )}
                            {meetData?.oldPrice && (
                                <div className="price old-price">Rp. {meetData.oldPrice}</div>
                            )}
                        </div>
                    </div>
                </div>

                <div className="course-content">                  

                    {![9, 10, 11].includes(hideiPassDuration) && (
                      <div className="course-meta meta-style-1 mb-2">  {/* label meet option */}
                          {Object.keys(data.meetOptions || {}).map((key) => (
                              <button
                                  key={key}
                                  onClick={() => handleSelectMeet(key)}
                                  className={`btn round  btn-meet me-2 ${selectedMeet === key ? 'option-active' : '' }`}
                              >
                                  {data.meetOptions[key].label}
                              </button>
                          ))}
                      </div>                     
                    )}

                      <div className="course-meta meta-style-1">
                          <span className="lessons">
                              <i className="ri-time-line"></i>
                              <span className='ps-1'>{meetData?.durationInHour || data.durationInHour}</span>
                          </span>
                      </div>                        


                    <h4>
                        <a href={`/course-details/${data.id}?meet=${selectedMeet}`}>{data.title}<br /> {data.subtitle}</a>
                        {/* <a onClick={goToCourseDetail} >{data.title}</a> */}
                    </h4>

                    <div className="course-footer mt-20 d-flex align-items-center justify-content-between">
                        <span className="students">
                            <i className="far fa-user-alt me-2"></i>
                            {data.student} {data.student === 1 ? "Student" : "Students"}
                        </span>
                        <a href={`/course-details/${data.id}?meet=${selectedMeet}`} className="rounded-btn">
                            <i className="fa fa-long-arrow-right"></i>
                        </a>
                        {/* <a onClick={goToCourseDetail} className="rounded-btn" role="button">
                            <i className="fa fa-long-arrow-right"></i>
                        </a>                         */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CourseTypeOne;
